import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  updateTeacher,
  deleteTeacher,
  UPDATE_TEACHER_SUCCESS_MESSAGE,
  ITeacherParam,
  teachersPath,
  fetchTeacher,
  fetchClasses,
  DELETE_TEACHER_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import TeacherForm from "../../../templates/manager/TeacherForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (
      state.success_message === UPDATE_TEACHER_SUCCESS_MESSAGE ||
      state.success_message === DELETE_TEACHER_SUCCESS_MESSAGE
    ) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(teachersPath);
    }
  }, [history, dispatch, state.success_message]);

  const updateTeacherFunc = React.useCallback(
    (userManager: ITeacherParam) => {
      dispatch(peep(updateTeacher(userManager)));
    },
    [dispatch, peep],
  );

  const deleteTeacherFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteTeacher(id)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchTeacher(id));
    dispatch(fetchClasses(currentYear, true));
  }, [dispatch, currentYear, id]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
    return () => dispatch(clearErrorMessage());
  }, [dispatch, state.error]);

  const teacher = state.teachers.find(t => t.id === id);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.teachers, to: teachersPath }]}
        currentTitle={titles.editTeacher}
      />
      {teacher && (
        <TeacherForm
          title={titles.editTeacher}
          classes={state.classes}
          calling={calling}
          error={state.error}
          school={state.manager.school!}
          teacher={teacher}
          isMyself={teacher.id === state.manager.id}
          upsertTeacher={updateTeacherFunc}
          deleteTeacher={deleteTeacherFunc}
        />
      )}
    </div>
  );
};
